<template>
  <div
    :id="line"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="gridSystemModalLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <header
            class="site-header-3 site-header"
            style="border-top: 5px solid #29b6f6"
          >
            <!-- Main bar start -->
            <div id="sticked-menu" class="main-bar">
              <div class="">
                <div class="row">
                  <div class="col-md-12">
                    <!-- logo begin -->
                    <div id="logo" class="site-logo">
                      <a :href="dadosconteudo.linklogo">
                        <img
                          :src="dadosconteudo.imglogo"
                          alt=""
                          class="logo logo-principal"
                        />
                        <div class="nomes-logo">
                          <span>{{ dadosconteudo.tipoentidade }}</span>
                          <h1>{{ dadosconteudo.nomeentidade }}</h1>
                        </div>
                      </a>
                    </div>
                    <!-- logo close -->
                    <div class="title-system pull-right" style="">
                      <p class="title-ouvi">{{ dadosconteudo.nomesistema }}</p>
                      <p class="sub-title-ouvi">
                        {{ dadosconteudo.modalidade }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <!-- <div class="">
                        <h4 class="block caption text-success text-success">CONSULTA DE EDITAL / PREGÃO PRESENCIAL</h4>
                    </div> -->
          <br />
          <div class="row">
            <div class="col-md-12">
              <div class="portlet-body">
                <div style="margin: 0 0 5px 0; font-weight: 500">
                  {{ dadosconteudo.modalidade }} - Nº
                  {{ dadosconteudo.numero }} / {{ dadosconteudo.ano }} -
                  Processo: {{ dadosconteudo.processo }}
                </div>
                <div class="table-scrollable">
                  <table class="table">
                    <tbody>
                      <!-- <tr>
                                                <td class="titulotable" width="19%" align="right" style="background-color: #eee;"> Modalidade </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.modalidade}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> Número </td>
                                                <td class="conteudotable"> {{dadosconteudo.numero}} </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" width="19%" align="right" style="background-color: #eee;"> Ano </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.ano}}
                                                </td>
                                            </tr> -->
                      <tr>
                        <td
                          class="titulotable"
                          align="right"
                          style="background-color: #eee"
                        >
                          CPF/CNPJ
                        </td>
                        <td class="conteudotable">
                          {{ dadosconteudo.cpfcnpj }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="titulotable"
                          align="right"
                          style="background-color: #eee"
                        >
                          Fornecedor
                        </td>
                        <td class="conteudotable">
                          {{ dadosconteudo.nomefornecedor }}
                        </td>
                      </tr>
                      <!-- <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> Processo
                                                <td class="conteudotable">
                                                    {{dadosconteudo.processo}}
                                                </td>
                                            </tr> -->
                      <!-- <tr>
                                                <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> Objeto </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.objeto}}
                                                </td> 
                                            </tr> -->
                      <tr>
                        <td
                          class="titulotable"
                          width="19%"
                          align="right"
                          style="
                            vertical-align: top !important;
                            background-color: #eee;
                          "
                        >
                          Fase
                        </td>
                        <td class="conteudotable">
                          <div class="portlet-body">
                            <div
                              class="table-scrollable"
                              style="overflow-y: auto; max-height: 155px"
                            >
                              <table class="table">
                                <thead class="">
                                  <tr>
                                    <th>Data</th>
                                    <th>Fase</th>
                                    <th>Arquivo</th>
                                    <th style="text-align: center !important">
                                      Diário Oficial
                                    </th>
                                    <th style="text-align: center !important">
                                      Data Publicação
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="infoanexo in dadosconteudo.anexos">
                                    <td>{{ infoanexo.data }}</td>
                                    <td>{{ infoanexo.fase }}</td>
                                    <td v-if="infoanexo.telamodal == false">
                                      <a
                                        :href="infoanexo.linkarquivo"
                                        target="_blank"
                                      >
                                        {{ infoanexo.arquivo }}
                                      </a>
                                    </td>
                                    <td v-else>
                                      <a
                                        href="javascript:;"
                                        data-toggle="modal"
                                        :data-target="'#' + infoanexo.moduser"
                                      >
                                        {{ infoanexo.arquivo }}
                                      </a>
                                    </td>
                                    <td style="text-align: center !important">
                                      <a
                                        :href="infoanexo.linkdiario"
                                        target="_blank"
                                        >{{ infoanexo.diariooficial }}</a
                                      >
                                    </td>
                                    <td style="text-align: center !important">
                                      {{ infoanexo.datapublicacao }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- FInal do modalbody-->
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Fechar
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
  <!-- Modal de informações -->
  <div v-for="userfase in dadosconteudo.anexos">
    <modal-user
      v-if="userfase.telamodal == true"
      :line="userfase"
      :idmodaln="userfase.moduser"
    ></modal-user>
  </div>
  <!-- fim Modal de informações -->
</template>
<script>
import ModalUser from "../modaluser/usermodal.vue";
export default {
  data() {
    return {
      dadosconteudo: {},
      imglogo: "./src/assets/images/logo.png",
    };
  },
  components: {
    ModalUser,
  },
  ready() {
    /* dados conteudo
                        dadosconteudo: {
                            modalidade: 'CHAMADA PÚBLICA',
                            numero: '001',
                            ano: '2017',
                            processo: '003277/2017',
                            cpfcnpj: '32.176.749/0001-80',
                            nomefornecedor: 'Fornecedor Nome Completo'
                        },
                    */
    $.ajaxSetup({
      async: false,
    });

    var self = this;
    //json com os dados do menu
    $("#" + self.line).on("show.bs.modal", function (e) {
      $.getJSON("./server/contrato.php", { id: self.line }, function (links) {
        self.dadosconteudo = links[0];
        //console.log(self.dadosconteudo)
      });
    });

    $.ajaxSetup({
      async: true,
    });
  },
  props: {
    line: {},
  },
};
</script>

<style scoped>
.table-scrollable {
  max-height: 383px;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// infomodal.vue?688d5082